'use strict';
const goldAsset = require('./gold-asset');
module.exports = function GoldIconUnpacker(imageDownloader, optional) {
	if (!imageDownloader) {
		throw 'invalid-args';
	}
	const self = this,
		siteAsset = function (url) {
			return url.startsWith('/assets/');
		},
		unpackImageAssetsFromSameMap = function (ideaArray, fileId) {
			if (!fileId || !ideaArray || !ideaArray.length) {
				return ideaArray || [];
			}
			const otherIdeas = [];
			ideaArray.forEach(function (idea) {
				const icon = idea && idea.attr && idea.attr.icon,
					iconMetadata = icon && goldAsset.isGoldAssetMetadata(icon.metaData);

				if (iconMetadata && iconMetadata.fileId === fileId) {
					icon.url = goldAsset.resourceIdFromAssetId(iconMetadata.assetId);
					delete icon.metaData;
				} else if (icon && icon.url && !siteAsset(icon.url)) {
					otherIdeas.push(idea);
				}
			});
			return otherIdeas;
		},
		downloadRemoteImageAssetsForSingleIdea = function (idea) {
			const icon = idea && idea.attr && idea.attr.icon,
				unpackGoldOnly = optional && optional.unpackGoldOnly,
				iconUrl = icon && icon.url;
			if (!iconUrl) {
				return Promise.resolve();
			}
			if (unpackGoldOnly && (!icon.metaData || !goldAsset.isGoldAssetMetadata(icon.metaData))) {
				return Promise.resolve();
			}
			return imageDownloader.convertToPng(iconUrl).then(function (dataUri) {
				icon.url = dataUri;
				delete icon.metaData;
			}).catch(() => delete idea.attr.icon);
		};
	self.unpack = function (ideaArray) {
		const fileId = optional && optional.pageState && optional.pageState.getFileId(),
			ideasWithDownloadableImages = unpackImageAssetsFromSameMap(ideaArray, fileId);
		return Promise.all(ideasWithDownloadableImages.map(downloadRemoteImageAssetsForSingleIdea));
	};
};
